import { Loader2 } from "lucide-react";

/** Suspense fallback shown while a lazily-loaded page chunk is fetched.
 *  Sits inside the portal shell, so the sidebar/header stay put. */
export function PageLoader() {
    return (
        <div data-testid="page-loader" className="flex items-center justify-center py-24">
            <Loader2 className="w-7 h-7 animate-spin text-phoenix-navy/60" />
        </div>
    );
}
